module.exports = "<svg id=\"a4eec0d8-22a9-4fea-a053-7400d98b8903\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>quotes</title><path d=\"M12.29,7.27a11.88,11.88,0,0,0,0,23.77h.32c2.5-.15-6,12.39-5.78,12.21,14.78-5.78,17.34-20.37,17.34-24.09A11.88,11.88,0,0,0,12.29,7.27Z\"></path><path d=\"M38,7.27A11.88,11.88,0,0,0,38,31h.32c2.5-.15-6,12.39-5.78,12.21,14.78-5.78,17.34-20.37,17.34-24.09A11.88,11.88,0,0,0,38,7.27Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/quotes.svg
// module id = 3GQY
// module chunks = 1